import { useFormContext, useWatch } from "react-hook-form";
import { TextInput, useNotify } from "react-admin";
import { Grid } from "@mui/material";
import IconSearch from "@mui/icons-material/Search";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from "../ui/button";
import { useState } from "react";
import useForRequest from "../ra/hook/useForRequest";

const SearchCustomer = ({ ...props }) =>
{
  const { action } = useForRequest();
  const form = useFormContext();
  const notify = useNotify();
  const customerPassportData = useWatch({ name: "customer_passport_data" });
  const [showLoading, setShowLoading] = useState(false);

  const btnSearchCustomerClick = async (e) =>
  {
    e.stopPropagation();

    if (!customerPassportData || customerPassportData === '')
      return;

    setShowLoading(true);
    const { response, error } = await action(`customer-passport-physical/search-customer`, 'POST', { term: customerPassportData });
    if (error || !response || !response.data || !response.data.result)
    {
      notify("Nenhum usuário encontrado!", { type: "error" });
      setShowLoading(false);
      return;
    }

    const values = form.getValues();
    form.reset({
      ...values,
      customer_passport_and_name: `Passaporte: ${response.data.result.passport_number} - ${response.data.result.profile_name}`,
      customerData: response.data.result
    });

    setShowLoading(false);
  };

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: '#288A79', zIndex: theme.zIndex.drawer + 1 })}
        open={showLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid size={{ xs: 12, md: 9 }}>
        <TextInput source="customer_passport_data" label="Digite o número do Passaporte ER ou Documento (CPF ou Passaporte))" fullWidth isRequired />
      </Grid>
      <Grid
        size={{ xs: 12, md: 3 }}
        sx={{
          display: "flex",
          justifyContent: { xs: "stretch", md: "flex-end" },
          alignItems: "flex-start",
        }}>
        <Button
          label="Buscar"
          color="primary"
          onClick={btnSearchCustomerClick}
          sx={{ width: { xs: "100%", md: "auto" }, minHeight: 40 }}>
          <IconSearch />
        </Button>
      </Grid>
    </>
  );
};

export default SearchCustomer;
